<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useOrientation } from '../composables'

const { t } = useI18n()
const { isLandscapeOnTouchDevice } = useOrientation()

const showOverlay = isLandscapeOnTouchDevice
const titleText = computed(() => t('orientation.title'))
const subtitleText = computed(() => t('orientation.subtitle'))
</script>

<template>
  <Transition name="orientation-fade">
    <div
      v-if="showOverlay"
      class="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black"
    >
      <!-- 手机旋转图标 -->
      <div class="relative mb-8">
        <!-- 手机外框 -->
        <div class="phone-icon">
          <div class="phone-screen"></div>
        </div>
        <!-- 旋转箭头 -->
        <svg
          class="rotate-arrow"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M4 4v5h5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4 9a8 8 0 0 1 14-5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <!-- 提示文字 -->
      <div class="text-center">
        <p class="mb-2 text-xl font-medium text-white md:text-2xl">{{ titleText }}</p>
        <p class="text-base text-white/70 md:text-lg">{{ subtitleText }}</p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.orientation-fade-enter-active,
.orientation-fade-leave-active {
  transition: opacity 0.3s ease;
}

.orientation-fade-enter-from,
.orientation-fade-leave-to {
  opacity: 0;
}

/* 手机图标样式 */
.phone-icon {
  width: 60px;
  height: 100px;
  border: 3px solid white;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 旋转动画 */
  animation: phone-rotate 2s ease-in-out infinite;
}

.phone-screen {
  width: 44px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

/* 旋转箭头 */
.rotate-arrow {
  position: absolute;
  width: 32px;
  height: 32px;
  color: #d4956a;
  top: -16px;
  right: -20px;
  animation: arrow-pulse 2s ease-in-out infinite;
}

@keyframes phone-rotate {
  0%,
  100% {
    transform: rotate(0deg);
  }
  25%,
  75% {
    transform: rotate(-90deg);
  }
}

@keyframes arrow-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(0.9);
  }
}
</style>
